import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Typography, Container, Chip } from "@mui/material";
import { useTheme } from "../../contexts/ThemeContext";
import PortfolioV2 from "./PortfolioV2";

const PortfolioV2Page = () => {
  const { currentTheme } = useTheme();
  const isLight = currentTheme.palette.mode === "light";

  return (
    <>
      <Helmet>
        <title>Portfolio | Vantage Alpha</title>
      </Helmet>

      <Box
        sx={{
          flex: "1 0 auto",
          width: "100%",
          height: "auto",
          minHeight: "100%",
          alignSelf: "stretch",
          backgroundColor: isLight
            ? "#ebebeb"
            : currentTheme.palette.grey[50],
          py: 3,
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            maxWidth: 1640,
            mx: "auto",
            px: { xs: 2, sm: 3 },
            "& .MuiTypography-caption": { fontSize: "0.875rem" },
            "& .MuiTypography-body2": { fontSize: "1rem" },
            "& .MuiTypography-subtitle2": { fontSize: "1rem" },
            "& .MuiInputBase-input": { fontSize: "0.95rem" },
            "& .MuiInputLabel-root": { fontSize: "0.9rem" },
            "& .MuiMenuItem-root": { fontSize: "0.95rem" },
          }}
        >
          <Box sx={{ mb: 2.5 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.25,
                mb: 0.5,
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: currentTheme.palette.text.primary,
                  letterSpacing: "-0.02em",
                  fontSize: { xs: "1.75rem", md: "2rem" },
                }}
              >
                Portfolio
              </Typography>
              <Chip
                label="New"
                size="small"
                sx={{
                  height: 22,
                  fontWeight: 800,
                  fontSize: "0.7rem",
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  color: "#fff",
                  backgroundColor: "#E53935",
                  "& .MuiChip-label": { px: 1 },
                }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{
                fontSize: "1rem",
                color:
                  currentTheme.palette.mode === "dark"
                    ? "#D0D0D0"
                    : currentTheme.palette.text.secondary,
              }}
            >
              Monitor portfolio performance, positions, and market data
            </Typography>
          </Box>

          <PortfolioV2 />
        </Container>
      </Box>
    </>
  );
};

export default PortfolioV2Page;
